import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation as useRouterLocation } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useLocation } from '../context/LocationContext';
import Icon from '@mdi/react';
import { mdiMenuDown } from '@mdi/js';
import './Navigation.css';

const Navigation = () => {
  const routerLocation = useRouterLocation();
  const { getCartCount, clearCart } = useCart();
  const { selectedLocation, updateLocation, requestLocationChange, locations } = useLocation();
  const cartCount = getCartCount();
  const [showLocationDropdown, setShowLocationDropdown] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowLocationDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLocationChange = (location) => {
    setShowLocationDropdown(false);

    // If location is the same, do nothing
    if (location === selectedLocation) {
      return;
    }

    // If cart has items, show confirmation modal
    if (cartCount > 0) {
      requestLocationChange(location, clearCart);
    } else {
      // If cart is empty, just update location
      updateLocation(location);
    }
  };

  return (
    <nav className="navigation">
      <div className="nav-container">
        <div className="nav-logo-section">
          <Link to="/" className="nav-logo">
            <h1>BELLE JOURNÉE BAKERY</h1>
          </Link>
          {selectedLocation && (
            <div className="location-selector" ref={dropdownRef}>
              <button
                className="location-display"
                onClick={() => setShowLocationDropdown(!showLocationDropdown)}
              >
                <span className="location-text">{selectedLocation}</span>
                <Icon path={mdiMenuDown} size={1} />
              </button>
              {showLocationDropdown && (
                <div className="location-dropdown">
                  {locations.map((location) => (
                    <button
                      key={location}
                      className={`location-dropdown-item ${
                        location === selectedLocation ? 'active' : ''
                      }`}
                      onClick={() => handleLocationChange(location)}
                    >
                      {location}
                    </button>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
        <div className="nav-links">
          <Link
            to="/"
            className={`nav-link ${routerLocation.pathname === '/' ? 'active' : ''}`}
          >
            Menu
          </Link>
          <Link
            to="/cart"
            state={{ fromApp: true }}
            className={`nav-link ${routerLocation.pathname === '/cart' ? 'active' : ''}`}
          >
            Cart
            {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
